import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { uploadReset, updateDoc } from "../../redux/Actions/SingleUserActions";
import Storage from "../../utils/storage";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import Dummy from "../../assets/assets/account.svg";
import { getDocs, getUserStatus, getRequiredDocs } from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import checkDocs from "../../utils/Functions/CheckCategory";
import Docs from "./Docs";
import UpdateArray from "../../utils/Functions/UpdateArray";
import Spinner from "react-spinner-material";
import { PropTypes } from "prop-types";

const UploadUpdate = ({
  isGetting,
  getDocsList,
  getStatus,
  dashboardData,
  isUpdating,
  updateSuccess,
  updateDoc,
  uploadReset,
  docs,
  isFetching,
  getStatusSuccess,
  requiredDocs,
  getRequiredDocs,
  isFetchingRequiredDocs,
  getRequiredDocsSuccess
}) => {
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;
  let categoryChoice = user && user.category_id;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      uploadReset();
      const type = "default"
      getRequiredDocs(type)
      getStatus();
    },
    // eslint-disable-next-line
    [uploadReset, getRequiredDocs, getStatus]
  );

  const appStatus = dashboardData && dashboardData[0] && dashboardData[0].default_application
  const userAppStatus2 = appStatus && appStatus[0] && appStatus[0].status;
  const userAppStatus =
    appStatus && appStatus[0] && appStatus[0].nibss_super_admin_status;
  const userAppId = appStatus && appStatus[0] && appStatus[0].id;

  useEffect(
    () => {
      if (getRequiredDocsSuccess) {
        const type = "default";
        getDocsList(type);
      }
    },
    // eslint-disable-next-line
    [getStatusSuccess, getDocsList]
  );

  const categoryDocs = requiredDocs && requiredDocs[categoryChoice] && requiredDocs[categoryChoice].documents

  const uploadedDocs = docs && docs[0] && docs[0].documents;

  checkDocs(categoryDocs, uploadedDocs);

  function handleDataFetch(fileResult) {
    let allResult = uploadedDocs;
    setState({
      allResult,
    });
    UpdateArray(allResult, fileResult);
    setState({ allResult });
  }

  const handleRemoval = fileResult => {
    state.allResult && state.allResult.splice(
      state.allResult.findIndex(item => item.id === fileResult.id),
      1
    );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult
  };

  const updateDocs = () => {
    const updateFiles = {
      application_id: userAppId && userAppId.toString(),
      application_type: "default",
      document: state.allResult,
    };

    updateDoc(updateFiles);
  };

  useEffect(
    () => {
      if (updateSuccess) {
        state.errorMessage = "";
        Alert(
          true,
          "success",
          "Success message",
          "Your application has been submitted for review."
        );
        history.push("/dashboard");
        setState({
          ...state,
          errorMessage: "",
        });
      }
    },
    // eslint-disable-next-line
    [updateSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <div>
          <div className="user-info">
            <div className="user-info-image">
              <img src={img || compImg || Dummy} alt="pic" />
            </div>
            <div className="user-info-names">
              <p>Welcome,</p>
              <h2>{name || username}</h2>
              <h4>
                Acceptance Status:
                {userAppStatus === "approved" &&
                  userAppStatus2 !== "rejected" && (
                    <span className="approved">{userAppStatus}</span>
                  )}
                {userAppStatus === "pending" &&
                  userAppStatus2 !== "rejected" && (
                    <span className="pending">{userAppStatus}</span>
                  )}
                {(userAppStatus === "rejected" ||
                  userAppStatus2 === "rejected") && (
                    <span className="rejected">Rejected</span>
                  )}
              </h4>
            </div>
          </div>
        </div>
        <div className="upload-title">
          <h2>Activation Documents</h2>
          <p>The documents we ask for are based on your business profile</p>
          <p>
            (Only pdf, png, jpeg and jpg formats are allowed with a max file
            size of 5MB)
          </p>
        </div>

        {isGetting || isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            getStatusSuccess && (
              <Docs
                isUpdating={isUpdating}
                isFetching={isFetching}
                updateDocs={updateDocs}
                handleDataFetch={handleDataFetch}
                handleRemoval={handleRemoval}
                categoryChoice={categoryChoice}
                categoryDocs={categoryDocs}
              />
            )
          )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUpdating: state.singleUser.isUpdating,
    updateSuccess: state.singleUser.updateSuccess,
    docs: state.docs.docs,
    dashboardData: state.docs.status,
    isFetching: state.docs.isFetching,
    isGetting: state.docs.isGetting,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateDoc: (payload) => dispatch(updateDoc(payload)),
  getDocsList: (type) => dispatch(getDocs(type)),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
});

UploadUpdate.propTypes = {
  dashboardData: PropTypes.array,
  docs: PropTypes.array,
  getDocsList: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isGetting: PropTypes.bool,
  isUpdating: PropTypes.bool,
  requiredDocs: PropTypes.object,
  updateDoc: PropTypes.func,
  updateSuccess: PropTypes.bool,
  uploadReset: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadUpdate);